import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';

// Components
import * as auth from './auth';
import { LanguageService } from './services/language.service';
import { SharedModule } from './shared/shared.module';
import { NewsComponent } from './news/news.component';

// import ngx-translate and the http loader
import { TranslatePipe, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// import @angular/material
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { NgHcaptchaModule } from 'ng-hcaptcha';
import { authInterceptor } from './auth.interceptor';
import { maintenanceInterceptor } from './maintenance.interceptor';
import { conflictInterceptor } from './conflict.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    auth.LoginComponent,
    auth.RegistrationSimpleComponent,
    auth.RegistrationComponent,
    auth.ResetPasswordComponent,
    auth.SetupPasswordComponent,
    auth.ConfirmAccountComponent,
    auth.ForgotPasswordComponent,
    NewsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    // Material
    MatSnackBarModule,
    AppRoutingModule,
    SharedModule,
    NgHcaptchaModule.forRoot({
      siteKey: '54969844-40c8-4246-b7fc-ae4add6aae08'
    }),
    // ngx-translate pipe for the components declared here
    TranslatePipe

  ],
  providers: [
    // The only HttpClient in the app (lazy modules use this one). Interceptors run in this order:
    // login token header (API_HOSTS in auth.interceptor.ts), maintenance page on 503, API text on 409.
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, maintenanceInterceptor, conflictInterceptor])),
    // The only TranslateService in the app (lazy modules just import TranslatePipe). The loader reads
    // /assets/i18n/{lang}.json through HttpClient; LanguageService sets the fallback and current language.
    provideTranslateService({
      loader: provideTranslateHttpLoader()
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private languageService: LanguageService) {
    this.languageService.setDefaultLang('en');
    this.languageService.applyAvailableLanguage();
  }
}
